type OrderDeliveryItem = {
    selectedQuantity?: number;
    deliveryRemainingQuantity?: number;
    deliverySentQuantity?: number;
    deliveryReturnedQuantity?: number;
};

const toNonNegativeNumber = (value: unknown): number | undefined => {
    const numberValue = Number(value);
    return Number.isFinite(numberValue)
        ? Math.max(numberValue, 0)
        : undefined;
};

export const getSuggestedDeliveryQuantity = (
    item: OrderDeliveryItem,
): number => {
    const requiredQuantity =
        toNonNegativeNumber(item.selectedQuantity) ?? 0;
    const remainingQuantity = toNonNegativeNumber(
        item.deliveryRemainingQuantity,
    );

    if (remainingQuantity === undefined) {
        return requiredQuantity;
    }

    return Math.min(remainingQuantity, requiredQuantity);
};

export const getRemainingDeliveryQuantity = (
    item: OrderDeliveryItem,
    previousQuantity?: number,
): number => {
    const ordered = toNonNegativeNumber(item.selectedQuantity) ?? 0;
    const remaining = toNonNegativeNumber(item.deliveryRemainingQuantity);
    const sent = toNonNegativeNumber(item.deliverySentQuantity);
    const returned = toNonNegativeNumber(item.deliveryReturnedQuantity);

    if (previousQuantity !== undefined) {
        const originalQuantity = toNonNegativeNumber(previousQuantity) ?? 0;
        if (sent !== undefined && returned !== undefined) {
            return Math.max(ordered - sent + returned + originalQuantity, 0);
        }
        return remaining === undefined ? ordered : Math.max(remaining + originalQuantity, 0);
    }
    return remaining ?? Math.max(ordered - (sent ?? 0) + (returned ?? 0), 0);
};

export const getDeliveryQuantityWarning = (input: {
    productCode: string;
    productName: string;
    quantity: number;
    remaining: number;
}): string | null => {
    const difference = input.quantity - input.remaining;
    if (difference === 0) return null;
    const product = [input.productCode, input.productName].filter(Boolean).join(" — ");
    return `${product}:\n`
        + `- Số lượng sẽ giao: ${input.quantity}\n`
        + `- Số lượng còn lại cần phải giao: ${input.remaining}\n`
        + `- Chênh lệch: ${difference > 0 ? "vượt" : "thiếu"} ${Math.abs(difference)}.`;
};
